(function () {
  'use strict';

  /*
   * Mobile WhatsApp support nudge.
   *
   * NOTE: The product help accordion items ("Wie messe ich richtig aus?" and
   * "Wie konfiguriere ich das Fliegengitter?") are NO LONGER injected here.
   * They now live as native content-toggles blocks inside each product template
   * and are fully editable in the Shopify theme editor. Keeping them native
   * avoids the previous problem of un-manageable, JS-injected FAQ content and
   * prevents wrong/duplicate tabs on products without the 2-step advisory flow.
   */

  var WHATSAPP_NUDGE_DELAY = 30000;
  var WHATSAPP_NUDGE_DURATION = 5000;
  var WHATSAPP_NUDGE_TTL = 24 * 60 * 60 * 1000;
  var WHATSAPP_NUDGE_TEXT = 'Brauchst du Beratung oder Support über WhatsApp?';
  var WHATSAPP_DISMISSED_KEY = 'nsWhatsappNudgeDismissed';

  function injectSupportStyles() {
    if (document.getElementById('ns-product-support-styles')) return;

    var style = document.createElement('style');
    style.id = 'ns-product-support-styles';
    style.textContent =
      '.ns-whatsapp-nudge{display:none}' +
      '@media (max-width:767px){' +
        '.ns-whatsapp-nudge{position:fixed;right:16px;bottom:94px;z-index:2147483000;display:block;width:min(258px,calc(100vw - 32px));padding:13px 38px 13px 15px;border:1px solid rgba(43,43,43,.12);border-radius:16px 16px 4px 16px;background:#fff;color:#2B2B2B;box-shadow:0 12px 32px rgba(0,0,0,.16);font-size:14px;line-height:1.35;font-weight:500;opacity:0;transform:translateY(10px) scale(.96);pointer-events:none;transition:opacity .28s ease,transform .28s ease}' +
        '.ns-whatsapp-nudge::after{content:"";position:absolute;right:18px;bottom:-7px;border-width:8px 8px 0 0;border-style:solid;border-color:#fff transparent transparent transparent;filter:drop-shadow(1px 2px 1px rgba(0,0,0,.06))}' +
        '.ns-whatsapp-nudge.is-visible{opacity:1;transform:translateY(0) scale(1);pointer-events:auto}' +
        '.ns-whatsapp-nudge__text{display:inline}' +
        '.ns-whatsapp-nudge__cursor{display:inline-block;width:1px;height:1em;margin-left:2px;background:currentColor;vertical-align:-2px;animation:nsWhatsappCursor .8s steps(1) infinite}' +
        '.ns-whatsapp-nudge__close{position:absolute;top:6px;right:7px;width:26px;height:26px;border:0;background:transparent;color:rgba(43,43,43,.62);font:inherit;font-size:20px;line-height:1;cursor:pointer}' +
        '@keyframes nsWhatsappCursor{50%{opacity:0}}' +
      '}';

    document.head.appendChild(style);
  }

  function getNudgeCookie() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + WHATSAPP_DISMISSED_KEY + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function isWhatsappNudgeSuppressed() {
    var now = Date.now();
    var storedUntil = null;

    try {
      storedUntil = Number(window.localStorage.getItem(WHATSAPP_DISMISSED_KEY));
    } catch (error) {}

    if (storedUntil && storedUntil > now) return true;

    var cookieUntil = Number(getNudgeCookie());
    return cookieUntil && cookieUntil > now;
  }

  function suppressWhatsappNudgeForOneDay() {
    var until = Date.now() + WHATSAPP_NUDGE_TTL;

    try {
      window.localStorage.setItem(WHATSAPP_DISMISSED_KEY, String(until));
    } catch (error) {}

    document.cookie = WHATSAPP_DISMISSED_KEY + '=' + encodeURIComponent(String(until)) + '; max-age=86400; path=/; SameSite=Lax';
  }

  function findWhatsappTarget() {
    return document.querySelector('a[href*="wa.me"],a[href*="whatsapp"],button[aria-label*="WhatsApp"],button[class*="whatsapp"],div[class*="whatsapp"] a,iframe[src*="whatsapp-button"]');
  }

  function typeNudgeText(textNode, cursorNode, text, onComplete) {
    var index = 0;
    var timer = window.setInterval(function () {
      index += 1;
      textNode.textContent = text.slice(0, index);

      if (index >= text.length) {
        window.clearInterval(timer);
        window.setTimeout(function () {
          cursorNode.style.display = 'none';
        }, 500);
        if (typeof onComplete === 'function') onComplete();
      }
    }, 38);
  }

  function showWhatsappNudge() {
    if (document.querySelector('.ns-whatsapp-nudge')) return;
    if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return;
    if (isWhatsappNudgeSuppressed()) return;

    suppressWhatsappNudgeForOneDay();
    injectSupportStyles();

    var nudge = document.createElement('div');
    nudge.className = 'ns-whatsapp-nudge';
    nudge.setAttribute('role', 'status');
    nudge.setAttribute('aria-live', 'polite');
    nudge.innerHTML =
      '<span class="ns-whatsapp-nudge__text"></span><span class="ns-whatsapp-nudge__cursor" aria-hidden="true"></span>' +
      '<button class="ns-whatsapp-nudge__close" type="button" aria-label="Hinweis schließen">×</button>';

    var textNode = nudge.querySelector('.ns-whatsapp-nudge__text');
    var cursorNode = nudge.querySelector('.ns-whatsapp-nudge__cursor');
    var closeButton = nudge.querySelector('.ns-whatsapp-nudge__close');
    var autoHideTimer = null;

    function hide() {
      nudge.classList.remove('is-visible');
      window.setTimeout(function () {
        if (nudge.parentNode) nudge.parentNode.removeChild(nudge);
      }, 300);
    }

    closeButton.addEventListener('click', function (event) {
      event.stopPropagation();
      suppressWhatsappNudgeForOneDay();
      window.clearTimeout(autoHideTimer);
      hide();
    });

    nudge.addEventListener('click', function () {
      var target = findWhatsappTarget();
      if (target && typeof target.click === 'function') target.click();
    });

    document.body.appendChild(nudge);
    window.requestAnimationFrame(function () {
      nudge.classList.add('is-visible');
      typeNudgeText(textNode, cursorNode, WHATSAPP_NUDGE_TEXT, function () {
        autoHideTimer = window.setTimeout(hide, WHATSAPP_NUDGE_DURATION);
      });
    });
  }

  function initWhatsappNudge() {
    if (!document.body.classList.contains('template-product')) return;
    window.setTimeout(showWhatsappNudge, WHATSAPP_NUDGE_DELAY);
  }

  function init() {
    injectSupportStyles();
    initWhatsappNudge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
